module.exports = __webpack_public_path__ + "static/media/google.7c3d1638.png";